// My Stats' Bright Pattern email columns (2026-11-02, Patrick's ask): the
// Support team is scored on one Email AHT across Bright Pattern (typed in from
// Power BI on the Scorecards tab) and CXHub. Combined = every email in both
// systems, CXHub Support Email included, total time over total count. It is
// shown only for a period whose Bright Pattern numbers are entered: before
// that it would be CXHub alone under a "Combined" heading, so it reads null
// ("—"), and the Total row pools only the entered periods.

function sides(data, period) {
  const bpCount = data.bpEmail?.emails?.[period] ?? 0
  const bpAht = data.bpEmail?.aht?.[period]
  const cxCount = data.allAccounts?.contacts?.[period] ?? 0
  const cxAht = data.allAccounts?.aht?.[period]
  return {
    bpCount: typeof bpAht === 'number' ? bpCount : 0,
    bpMs: typeof bpAht === 'number' ? bpAht * bpCount : 0,
    cxCount: typeof cxAht === 'number' ? cxCount : 0,
    cxMs: typeof cxAht === 'number' ? cxAht * cxCount : 0,
  }
}

export function hasBpEmail(data) {
  return Boolean(data?.bpEmail && Object.keys(data.bpEmail.emails ?? {}).length)
}

// One period: { bpEmails, bpAht, combinedEmails, combinedAht }.
export function periodBpEmail(data, period) {
  if (data.bpEmail?.emails?.[period] == null) return { bpEmails: null, bpAht: null, combinedEmails: null, combinedAht: null }
  const s = sides(data, period)
  const count = s.bpCount + s.cxCount
  return {
    bpEmails: s.bpCount,
    bpAht: data.bpEmail.aht[period],
    combinedEmails: count,
    combinedAht: count > 0 ? (s.bpMs + s.cxMs) / count : null,
  }
}

// The Total row, pooled sum over sum across the periods shown.
export function totalBpEmail(data, periods) {
  let bpCount = 0, bpMs = 0, count = 0, ms = 0
  for (const p of periods) {
    if (data.bpEmail?.emails?.[p] == null) continue
    const s = sides(data, p)
    bpCount += s.bpCount
    bpMs += s.bpMs
    count += s.bpCount + s.cxCount
    ms += s.bpMs + s.cxMs
  }
  return {
    bpEmails: bpCount,
    bpAht: bpCount > 0 ? bpMs / bpCount : null,
    combinedEmails: count,
    combinedAht: count > 0 ? ms / count : null,
  }
}
